export const body = {
    // border: "1px solid blue",
    height: "100%",
    overflow: "hidden"
};
